import Vue from 'vue';
import Router from 'vue-router';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';

var _7bd3ae9e = () => interopDefault(import('../pages/monitoring.vue'
/* webpackChunkName: "pages/monitoring" */
));

var _5852ef62 = () => interopDefault(import('../pages/redirect_url.vue'
/* webpackChunkName: "pages/redirect_url" */
));

var _72d13760 = () => interopDefault(import('../pages/tools/grid.vue'
/* webpackChunkName: "pages/tools/grid" */
));

var _5ca6ed60 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "pages/_market/_language/index" */
));

var _70389c02 = () => interopDefault(import('../pages/_market/_language/cart.vue'
/* webpackChunkName: "pages/_market/_language/cart" */
));

var _5cde1034 = () => interopDefault(import('../pages/_market/_language/help/index.vue'
/* webpackChunkName: "pages/_market/_language/help/index" */
));

var _264e9077 = () => interopDefault(import('../pages/_market/_language/login.vue'
/* webpackChunkName: "pages/_market/_language/login" */
));

var _9021969c = () => interopDefault(import('../pages/_market/_language/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/lost-password" */
));

var _1472313b = () => interopDefault(import('../pages/_market/_language/reset-password.vue'
/* webpackChunkName: "pages/_market/_language/reset-password" */
));

var _2045290c = () => interopDefault(import('../pages/_market/_language/signup.vue'
/* webpackChunkName: "pages/_market/_language/signup" */
));

var _109b2af4 = () => interopDefault(import('../pages/_market/_language/sitemap/index.vue'
/* webpackChunkName: "pages/_market/_language/sitemap/index" */
));

var _3a3c86bb = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "pages/_market/_language/store-locator/index" */
));

var _48ec6ff0 = () => interopDefault(import('../pages/_market/_language/user/index.vue'
/* webpackChunkName: "pages/_market/_language/user/index" */
));

var _96cac058 = () => interopDefault(import('../pages/_market/_language/help/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/confirm" */
));

var _ca1ca180 = () => interopDefault(import('../pages/_market/_language/help/deliveryConfirm.vue'
/* webpackChunkName: "pages/_market/_language/help/deliveryConfirm" */
));

var _4ff48bd1 = () => interopDefault(import('../pages/_market/_language/s/catalogue-luminaires.vue'
/* webpackChunkName: "pages/_market/_language/s/catalogue-luminaires" */
));

var _5b0f205e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "pages/_market/_language/s/home-by-me" */
));

var _f39a1aec = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "pages/_market/_language/s/lighting" */
));

var _bb26fa46 = () => interopDefault(import('../pages/_market/_language/s/sustainable-development.vue'
/* webpackChunkName: "pages/_market/_language/s/sustainable-development" */
));

var _bc74dadc = () => interopDefault(import('../pages/_market/_language/t/confirmed.vue'
/* webpackChunkName: "pages/_market/_language/t/confirmed" */
));

var _afb721c8 = () => interopDefault(import('../pages/_market/_language/t/login.vue'
/* webpackChunkName: "pages/_market/_language/t/login" */
));

var _7d229e57 = () => interopDefault(import('../pages/_market/_language/t/lost-password.vue'
/* webpackChunkName: "pages/_market/_language/t/lost-password" */
));

var _74ebbf0e = () => interopDefault(import('../pages/_market/_language/t/payment.vue'
/* webpackChunkName: "pages/_market/_language/t/payment" */
));

var _acab3442 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-canceled.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-canceled" */
));

var _18c157c1 = () => interopDefault(import('../pages/_market/_language/t/payment-paypal-pending.vue'
/* webpackChunkName: "pages/_market/_language/t/payment-paypal-pending" */
));

var _5a6ec77a = () => interopDefault(import('../pages/_market/_language/t/refused.vue'
/* webpackChunkName: "pages/_market/_language/t/refused" */
));

var _178d946a = () => interopDefault(import('../pages/_market/_language/t/shipping.vue'
/* webpackChunkName: "pages/_market/_language/t/shipping" */
));

var _ae793d16 = () => interopDefault(import('../pages/_market/_language/t/signup.vue'
/* webpackChunkName: "pages/_market/_language/t/signup" */
));

var _278698cc = () => interopDefault(import('../pages/_market/_language/user/gift-card-download.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-card-download" */
));

var _68861350 = () => interopDefault(import('../pages/_market/_language/user/gift-cards.vue'
/* webpackChunkName: "pages/_market/_language/user/gift-cards" */
));

var _0fc73f7a = () => interopDefault(import('../pages/_market/_language/user/orders/index.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/index" */
));

var _8def7872 = () => interopDefault(import('../pages/_market/_language/user/profile.vue'
/* webpackChunkName: "pages/_market/_language/user/profile" */
));

var _474e990a = () => interopDefault(import('../pages/_market/_language/user/profile/index.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/index" */
));

var _4911b3da = () => interopDefault(import('../pages/_market/_language/user/profile/addresses.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/addresses" */
));

var _27cae1e2 = () => interopDefault(import('../pages/_market/_language/user/profile/alerts.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/alerts" */
));

var _24872d13 = () => interopDefault(import('../pages/_market/_language/user/profile/password.vue'
/* webpackChunkName: "pages/_market/_language/user/profile/password" */
));

var _100e7a97 = () => interopDefault(import('../pages/_market/_language/user/wishlist.vue'
/* webpackChunkName: "pages/_market/_language/user/wishlist" */
));

var _a823ced6 = () => interopDefault(import('../pages/_market/_language/help/merchant/confirm.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/confirm" */
));

var _d204071c = () => interopDefault(import('../pages/_market/_language/configurator/product/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/product/_model" */
));

var _13b9ed9b = () => interopDefault(import('../pages/_market/_language/e/magazine/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/magazine/_slug" */
));

var _1100c908 = () => interopDefault(import('../pages/_market/_language/help/contact/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/contact/_form" */
));

var _203af7f8 = () => interopDefault(import('../pages/_market/_language/help/faq/_answer.vue'
/* webpackChunkName: "pages/_market/_language/help/faq/_answer" */
));

var _5b977ba0 = () => interopDefault(import('../pages/_market/_language/help/return/_form.vue'
/* webpackChunkName: "pages/_market/_language/help/return/_form" */
));

var _74c6b354 = () => interopDefault(import('../pages/_market/_language/user/orders/_reference.vue'
/* webpackChunkName: "pages/_market/_language/user/orders/_reference" */
));

var _79fb3db5 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/index.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/index" */
));

var _0847a1ac = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/messages.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/messages" */
));

var _e7798240 = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/notation.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/notation" */
));

var _5044e68f = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/product/_code.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/product/_code" */
));

var _7bc5eeaf = () => interopDefault(import('../pages/_market/_language/help/merchant/_order/_reference/contact/_code.vue'
/* webpackChunkName: "pages/_market/_language/help/merchant/_order/_reference/contact/_code" */
));

var _4b0729df = () => interopDefault(import('../pages/_market/_language/c/_alias.vue'
/* webpackChunkName: "pages/_market/_language/c/_alias" */
));

var _5535a352 = () => interopDefault(import('../pages/_market/_language/configurator/_model.vue'
/* webpackChunkName: "pages/_market/_language/configurator/_model" */
));

var _29664626 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "pages/_market/_language/inspirations/_slug" */
));

var _d010c0d6 = () => interopDefault(import('../pages/_market/_language/m/_alias.vue'
/* webpackChunkName: "pages/_market/_language/m/_alias" */
));

var _a1e6e09c = () => interopDefault(import('../pages/_market/_language/p/_alias.vue'
/* webpackChunkName: "pages/_market/_language/p/_alias" */
));

var _18343c2c = () => interopDefault(import('../pages/_market/_language/q/_keyword.vue'
/* webpackChunkName: "pages/_market/_language/q/_keyword" */
));

var _390bb018 = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "pages/_market/_language/e/_alias/_slug" */
));

var _d3e9a946 = () => interopDefault(import('../pages/_market/_language/index.vue'
/* webpackChunkName: "" */
));

var _63bd6b49 = () => interopDefault(import('../pages/_market/_language/inspirations/_slug.vue'
/* webpackChunkName: "" */
));

var _52a6eaad = () => interopDefault(import('../pages/_market/_language/s/lighting.vue'
/* webpackChunkName: "" */
));

var _4b34c87e = () => interopDefault(import('../pages/_market/_language/s/home-by-me.vue'
/* webpackChunkName: "" */
));

var _3cb0debb = () => interopDefault(import('../pages/_market/_language/e/_alias/_slug.vue'
/* webpackChunkName: "" */
));

var _4aca05f8 = () => interopDefault(import('../pages/_market/_language/store-locator/index.vue'
/* webpackChunkName: "" */
)); // TODO: remove in Nuxt 3


var emptyFn = () => {};

var originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
  var onAbort = arguments.length > 2 ? arguments[2] : undefined;
  return originalPush.call(this, location, onComplete, onAbort);
};

Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,
  routes: [{
    path: "/monitoring",
    component: _7bd3ae9e,
    name: "monitoring"
  }, {
    path: "/redirect_url",
    component: _5852ef62,
    name: "redirect_url"
  }, {
    path: "/tools/grid",
    component: _72d13760,
    name: "tools-grid"
  }, {
    path: "/:market?/:language",
    component: _5ca6ed60,
    name: "market-language"
  }, {
    path: "/:market?/:language?/cart",
    component: _70389c02,
    name: "market-language-cart"
  }, {
    path: "/:market?/:language?/help",
    component: _5cde1034,
    name: "market-language-help"
  }, {
    path: "/:market?/:language?/login",
    component: _264e9077,
    name: "market-language-login"
  }, {
    path: "/:market?/:language?/lost-password",
    component: _9021969c,
    name: "market-language-lost-password"
  }, {
    path: "/:market?/:language?/reset-password",
    component: _1472313b,
    name: "market-language-reset-password"
  }, {
    path: "/:market?/:language?/signup",
    component: _2045290c,
    name: "market-language-signup"
  }, {
    path: "/:market?/:language?/sitemap",
    component: _109b2af4,
    name: "market-language-sitemap"
  }, {
    path: "/:market?/:language?/store-locator",
    component: _3a3c86bb,
    name: "market-language-store-locator"
  }, {
    path: "/:market?/:language?/user",
    component: _48ec6ff0,
    name: "market-language-user"
  }, {
    path: "/:market?/:language?/help/confirm",
    component: _96cac058,
    name: "market-language-help-confirm"
  }, {
    path: "/:market?/:language?/help/deliveryConfirm",
    component: _ca1ca180,
    name: "market-language-help-deliveryConfirm"
  }, {
    path: "/:market?/:language?/s/catalogue-luminaires",
    component: _4ff48bd1,
    name: "market-language-s-catalogue-luminaires"
  }, {
    path: "/:market?/:language?/s/home-by-me",
    component: _5b0f205e,
    name: "market-language-s-home-by-me"
  }, {
    path: "/:market?/:language?/s/lighting",
    component: _f39a1aec,
    name: "market-language-s-lighting"
  }, {
    path: "/:market?/:language?/s/sustainable-development",
    component: _bb26fa46,
    name: "market-language-s-sustainable-development"
  }, {
    path: "/:market?/:language?/t/confirmed",
    component: _bc74dadc,
    name: "market-language-t-confirmed"
  }, {
    path: "/:market?/:language?/t/login",
    component: _afb721c8,
    name: "market-language-t-login"
  }, {
    path: "/:market?/:language?/t/lost-password",
    component: _7d229e57,
    name: "market-language-t-lost-password"
  }, {
    path: "/:market?/:language?/t/payment",
    component: _74ebbf0e,
    name: "market-language-t-payment"
  }, {
    path: "/:market?/:language?/t/payment-paypal-canceled",
    component: _acab3442,
    name: "market-language-t-payment-paypal-canceled"
  }, {
    path: "/:market?/:language?/t/payment-paypal-pending",
    component: _18c157c1,
    name: "market-language-t-payment-paypal-pending"
  }, {
    path: "/:market?/:language?/t/refused",
    component: _5a6ec77a,
    name: "market-language-t-refused"
  }, {
    path: "/:market?/:language?/t/shipping",
    component: _178d946a,
    name: "market-language-t-shipping"
  }, {
    path: "/:market?/:language?/t/signup",
    component: _ae793d16,
    name: "market-language-t-signup"
  }, {
    path: "/:market?/:language?/user/gift-card-download",
    component: _278698cc,
    name: "market-language-user-gift-card-download"
  }, {
    path: "/:market?/:language?/user/gift-cards",
    component: _68861350,
    name: "market-language-user-gift-cards"
  }, {
    path: "/:market?/:language?/user/orders",
    component: _0fc73f7a,
    name: "market-language-user-orders"
  }, {
    path: "/:market?/:language?/user/profile",
    component: _8def7872,
    children: [{
      path: "",
      component: _474e990a,
      name: "market-language-user-profile"
    }, {
      path: "addresses",
      component: _4911b3da,
      name: "market-language-user-profile-addresses"
    }, {
      path: "alerts",
      component: _27cae1e2,
      name: "market-language-user-profile-alerts"
    }, {
      path: "password",
      component: _24872d13,
      name: "market-language-user-profile-password"
    }]
  }, {
    path: "/:market?/:language?/user/wishlist",
    component: _100e7a97,
    name: "market-language-user-wishlist"
  }, {
    path: "/:market?/:language?/help/merchant/confirm",
    component: _a823ced6,
    name: "market-language-help-merchant-confirm"
  }, {
    path: "/:market?/:language?/configurator/product/:model?",
    component: _d204071c,
    name: "market-language-configurator-product-model"
  }, {
    path: "/:market?/:language?/e/magazine/:slug?",
    component: _13b9ed9b,
    name: "market-language-e-magazine-slug"
  }, {
    path: "/:market?/:language?/help/contact/:form?",
    component: _1100c908,
    name: "market-language-help-contact-form"
  }, {
    path: "/:market?/:language?/help/faq/:answer?",
    component: _203af7f8,
    name: "market-language-help-faq-answer"
  }, {
    path: "/:market?/:language?/help/return/:form?",
    component: _5b977ba0,
    name: "market-language-help-return-form"
  }, {
    path: "/:market?/:language?/user/orders/:reference",
    component: _74c6b354,
    name: "market-language-user-orders-reference"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact",
    component: _79fb3db5,
    name: "market-language-help-merchant-order-reference-contact"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/messages",
    component: _0847a1ac,
    name: "market-language-help-merchant-order-reference-messages"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/notation",
    component: _e7798240,
    name: "market-language-help-merchant-order-reference-notation"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/product/:code?",
    component: _5044e68f,
    name: "market-language-help-merchant-order-reference-contact-product-code"
  }, {
    path: "/:market?/:language?/help/merchant/:order?/:reference?/contact/:code",
    component: _7bc5eeaf,
    name: "market-language-help-merchant-order-reference-contact-code"
  }, {
    path: "/:market?/:language?/c/:alias?",
    component: _4b0729df,
    name: "market-language-c-alias"
  }, {
    path: "/:market?/:language?/configurator/:model?",
    component: _5535a352,
    name: "market-language-configurator-model"
  }, {
    path: "/:market?/:language?/inspirations/:slug?",
    component: _29664626,
    name: "market-language-inspirations-slug"
  }, {
    path: "/:market?/:language?/m/:alias?",
    component: _d010c0d6,
    name: "market-language-m-alias"
  }, {
    path: "/:market?/:language?/p/:alias?",
    component: _a1e6e09c,
    name: "market-language-p-alias"
  }, {
    path: "/:market?/:language?/q/:keyword?",
    component: _18343c2c,
    name: "market-language-q-keyword"
  }, {
    path: "/:market?/:language?/e/:alias?/:slug?",
    component: _390bb018,
    name: "market-language-e-alias-slug"
  }, {
    path: "/",
    component: _d3e9a946,
    name: "market-language-home-fr"
  }, {
    path: "/:market/:language/inspirations*",
    component: _63bd6b49,
    name: "market-language-inspirations-fr"
  }, {
    path: "/:market/:language/inspirationen*",
    component: _63bd6b49,
    name: "market-language-inspirations-de"
  }, {
    path: "/:market/:language/ispirazione*",
    component: _63bd6b49,
    name: "market-language-inspirations-it"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-en"
  }, {
    path: "/:market/:language/inspiration*",
    component: _63bd6b49,
    name: "market-language-inspirations-pt"
  }, {
    path: "/:market/:language/inspiracion*",
    component: _63bd6b49,
    name: "market-language-inspirations-es"
  }, {
    path: "/:market/:language/s/inspiratie*",
    component: _63bd6b49,
    name: "market-language-inspirations-nl"
  }, {
    path: "/:market/:language/s/luminaires*",
    component: _52a6eaad,
    name: "market-language-lighting-fr"
  }, {
    path: "/:market/:language/s/leuchten*",
    component: _52a6eaad,
    name: "market-language-lighting-de"
  }, {
    path: "/:market/:language/s/illuminazioni*",
    component: _52a6eaad,
    name: "market-language-lighting-it"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-en"
  }, {
    path: "/:market/:language/s/lighting*",
    component: _52a6eaad,
    name: "market-language-lighting-pt"
  }, {
    path: "/:market/:language/s/lamparas*",
    component: _52a6eaad,
    name: "market-language-lighting-es"
  }, {
    path: "/:market/:language/s/verlichting*",
    component: _52a6eaad,
    name: "market-language-lighting-nl"
  }, {
    path: "/:market/:language/s/atelier-deco*",
    component: _4b34c87e,
    name: "market-language-home-by-me-fr"
  }, {
    path: "/:market/:language/s/atelier-arredo*",
    component: _4b34c87e,
    name: "market-language-home-by-me-it"
  }, {
    path: "/:market/:language/s/taller-de-decoracion*",
    component: _4b34c87e,
    name: "market-language-home-by-me-es"
  }, {
    path: "/:market/:language/s/dekowerkstatt*",
    component: _4b34c87e,
    name: "market-language-home-by-me-de"
  }, {
    path: "/:market/:language/s/decor-workshop*",
    component: _4b34c87e,
    name: "market-language-home-by-me-en"
  }, {
    path: "/:market/:language/:alias/:slug",
    component: _3cb0debb,
    name: "market-language-editorial"
  }, {
    path: "/:market/:language/magasins/",
    component: _4aca05f8,
    name: "store-locator"
  }],
  fallback: false
};
export function createRouter() {
  var router = new Router(routerOptions);
  var resolve = router.resolve.bind(router); // encodeURI(decodeURI()) ~> support both encoded and non-encoded urls

  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = encodeURI(decodeURI(to));
    }

    return resolve(to, current, append);
  };

  return router;
}